import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { bonusSchema } from '../types';

export const createUnblockBonusMutation = () =>
	createAuthMutation({
		params: declareParams<number>(),
		request: {
			method: 'POST',
			url: (id) => `/bonus/unlock/${id}`,
			body: () => ({}),
		},
		response: {
			contract: zodContract(bonusSchema),
		},
	});
